import React, { createContext } from 'react';

import { FaqPageContextProps } from '@/features/faq-page/type';

export const FaqPageContext = createContext<FaqPageContextProps>({
  faqPageStaticData: {
    searchAdventures: {},
    relatedLinks: {},
    jobBlocks: {},
    regions: [],
    faqPageListings: {},
  },
});

export default function FaqPageContextProvider(props: FaqPageContextProps) {
  return (
    <FaqPageContext.Provider value={props}>
      {props.children}
    </FaqPageContext.Provider>
  );
}
